import {lazy} from 'react'
import * as B from '../block'
import {meta} from './meta'
import {ThemeBlock as InnerBlock} from './ThemeBlock'

const Admin = lazy(() => import('./admin').then(m => ({default: m.Admin})))

const GlobalAdmin = lazy(() =>
  import('./admin').then(m => ({default: m.GlobalAdmin})),
)

export const themeBlockInfo = B.blockInfo({
  ...meta,
  Admin,
  GlobalAdmin,
  InnerBlock,
  wrapperDiv: false,
})
